
class CartWatcher {
  constructor() {
    this.initialLoad = true; // Flag to track if this is the first load
    this.previousItemCount = 0; // Track the previous item count (not price)
  }

  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  // Fetch the current cart data
  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  // Store the cart data to localStorage
  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  // Retrieve the stored cart data from localStorage
  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  // Calculate the total item count in the cart
  calculateItemCount(cart) {
    return cart.items.reduce((total, item) => total + item.quantity, 0);
  }

  // Compare the old item count with the new one
  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();

    const newItemCount = this.calculateItemCount(newCart);
    const oldItemCount = this.calculateItemCount(oldCart);

    // Compare the item counts to check if the cart has increased or decreased
    const hasIncreased = newItemCount > oldItemCount;

    if (hasIncreased) {
      // Show the modal if the cart has increased (increased quantity of items)
      const event = new CustomEvent("cart_changed", { detail: { increased: true } });
      window.dispatchEvent(event);
    }

    // Store the new cart and update the previous item count
    this.storeCart(newCart);
    this.previousItemCount = newItemCount; // Update previous item count for next comparison
  }

  // Observe changes to the cart (based on resource fetches)
  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }

   async getCartItemCount() {
      const cart = await this.fetchCart();
      return cart.items.length;
    }
    async getCartItemQuantity() {
      const cart = await this.fetchCart();
      return cart.items;
    }
  
    // Method to get the total discount amount
    async getCartDiscount() {
      const cart = await this.fetchCart();
      return cart.total_discount; // Total discount applied
    }
  
    // Method to calculate the discount percentage
    async getDiscountPercentage() {
      const cart = await this.fetchCart();
      const originalPrice = cart.items.reduce((total, item) => total + item.original_price * item.quantity, 0);
      const totalDiscount = cart.total_discount;
  
      if (originalPrice > 0) {
        const discountPercentage = (totalDiscount / originalPrice) * 100;
        return discountPercentage.toFixed();  // Return discount percentage rounded to 2 decimal places
      }
      return 0; // Return 0 if no original price is available
    }
}

const myCartWatcher = new CartWatcher();
myCartWatcher.init();

window.addEventListener("cart_changed", event => {
  const existingModal = document.querySelector('.cart-modal');
  if (existingModal) {
    existingModal.remove();
  }
  if (event.detail.increased == true) {
    console.log(event.detail);
    showCartModal(event);
  }
});
// Function to display the cart modal
async function showCartModal(event) {
  const changes = event.detail;

  // Remove any existing modal
    

    // Fetch the number of items, total discount, and discount percentage
    const itemCount = await myCartWatcher.getCartItemCount();
   const ItemQuantity = await myCartWatcher.getCartItemQuantity();
    let doMore = '';
    
    let totalQuantity = 0;

    for (let item of ItemQuantity) {
      totalQuantity += item.quantity;
    }
  
    // Show different messages based on totalQuantity
    switch (totalQuantity) {
      case 1:
        doMore = "Add one more outfit to your cart and enjoy 30% off your entire purchase.";
        break;
      case 2:
        doMore = "Add one more outfit to your cart and enjoy 35% off your entire purchase.";
        break;
      case 3:
        doMore = "";
        break;
      default:
        
    }
  if(totalQuantity > 3){
    return;
  }
    const discountAmount = await myCartWatcher.getCartDiscount();
    const discountPercentage = await myCartWatcher.getDiscountPercentage();
  
    // Create the modal container
    const modal = document.createElement('div');
    modal.classList.add('cart-modal'); // Add a class for styling later if needed
  
    // Create the modal content box
    const modalContent = document.createElement('div');
    modalContent.classList.add('cart-modal-content'); // Add a class for styling later
  
  
  
    // Message about items added
    const modalMessage = document.createElement('div');
    modalMessage.textContent = ``;
    //modalContent.appendChild(modalMessage);
  
    // Display the item count and discount info in the modal
    const cartInfo = document.createElement('div');
    const span = document.createElement('span');

    cartInfo.innerHTML = `<div class="gifImg"><img class='firecracker' src="https://cdn.shopify.com/s/files/1/1919/6837/t/18/assets/firecracker.png?v=1744246406" /></div><h2>Congratulations</h2>
   
    <p class='congrats_text'>You have got <span>${discountPercentage}%</span> DISCOUNT</p>
    <div class='doMore' >${doMore}</div>
    `;
    modalContent.appendChild(cartInfo);
  
    // Add a close button to the modal
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.classList.add('cart-modal-close'); // Add a class for styling later
    closeButton.addEventListener('click', () => {
      modal.remove(); // Remove modal from DOM
    });
  
   // modalContent.appendChild(closeButton);
    modal.appendChild(modalContent);
  
    // Append the modal to the body
    document.body.appendChild(modal);

    setTimeout(function () {
       const existingModal = document.querySelector('.cart-modal');
        if (existingModal) {
          existingModal.remove();
        }
    }, 5000);
  //}
}

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener('click', function(event) {
    const existingModal = document.querySelector('.cart-modal');
    if (existingModal) {
      existingModal.remove();
    }
  });
  
});

